import React, { useState } from 'react';
import useStyle from './avatarChoiceBlock.style';
import { Avatar } from '../../../../types/avatar/avatarList.def';
import { mediaDir } from '../../../../appolloConfig';
import { FlatIcon } from '../../../atoms/Icons/FlatIcon';
import { classNames } from '../../../../helpers/style/classNames';
import { ButtonWithText } from '../../../atoms/Buttons/ButtonWithText';
import { ID } from 'types/typeDef';
import { HeaderText } from '../../../atoms/Texts/HeaderText';
import emojis from '../../../../theme/emoji';
import { OnUserAvatarMutationVariables } from '../../../../graphql/generated/graphql';
import { CarouselNav } from 'components/molecules/Carousel/CarouselNav';
import { carouselLoop } from 'helpers/carousel/carsouelLoop';
import { carouselAvatarPages } from 'helpers/carousel/carouselAvatarPages';
import { FeatureContainer } from 'components/molecules/Containers/FeatureContainer';
import { getAvatarCategoryName } from 'helpers/avatar/getAvatarCategoryName';
import { getAvatarVariantName } from 'helpers/avatar/getAvatarVariantName';
import { avatarErrorMessage } from 'helpers/avatar/error/avatarErrorMessage';
import { Avatar as AvatarComponent } from 'components/atoms/Avatar';

interface AvatarChoiceBlockViewProps {
  currentAvatar: string | null;
  setAvatar: (value) => void;
  avatars: Array<Avatar>;
  updateUserAvatar: (value: {
    variables: OnUserAvatarMutationVariables;
  }) => void;
  userid: ID;
  displayBronze?: boolean;
  displaySilver?: boolean;
  displayGold?: boolean;
  displayHalloween?: boolean;
  visibleTitle?: boolean;
}

export const AvatarChoiceBlockView = ({
  currentAvatar,
  setAvatar,
  avatars,
  updateUserAvatar,
  userid,
  displayBronze = true,
  displaySilver = true,
  displayGold = false,
  displayHalloween = false,
  visibleTitle
}: AvatarChoiceBlockViewProps) => {
  const classes = useStyle();
  const [page, setPage] = useState(0);
  const FilteredsAvatars = carouselAvatarPages(
    avatars,
    page,
    displayBronze,
    displaySilver,
    displayGold,
    displayHalloween
  );
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const startHalloweenDate = new Date(currentYear, 9, 23);
  const endHalloweenDate = new Date(currentYear, 10, 13);
  const NumberOfPages =
    currentDate >= startHalloweenDate && currentDate <= endHalloweenDate
      ? 13
      : 12;
  return (
    <div className={classes.container}>
      {visibleTitle && (
        <>
          <HeaderText text={'Mon avatar'} emoji={emojis['CardIndex']} />
          <p className={classes.text}>
            Cliquez sur l’avatar de votre choix puis validez pour confirmer le
            changement
          </p>
        </>
      )}
      <FeatureContainer padding="small">
        <CarouselNav
          text={getAvatarCategoryName(page)}
          previous={() => setPage(carouselLoop(page - 1, NumberOfPages))}
          next={() => setPage(carouselLoop(page + 1, NumberOfPages))}
          variant={getAvatarVariantName(page)}
        />
        <div className={classes.avatars}>
          {FilteredsAvatars.length > 0 ? (
            FilteredsAvatars.map(avatar => {
              return (
                <div
                  className={classNames([], {
                    condition: currentAvatar === avatar?.id?.toString(),
                    classe: classes.relativeAvatar
                  })}
                  key={avatar?.id}
                  onClick={() => {
                    setAvatar(avatar?.id);
                  }}
                >
                  <AvatarComponent
                    source={avatar?.media && mediaDir + avatar?.media?.url}
                    alt={avatar?.name}
                    variant="large"
                  />
                  {currentAvatar === avatar?.id?.toString() && (
                    <div className={classes.badge}>
                      <FlatIcon icon={'BadgeCheck'} />
                    </div>
                  )}
                </div>
              );
            })
          ) : (
            <div className={classes.noavatars}>
              <h3>
                Verrouillé{' '}
                <span role="img" aria-label="cadenas">
                  🔒
                </span>
              </h3>
              <p>{avatarErrorMessage(page)}</p>
            </div>
          )}
        </div>
        <div>
          <ButtonWithText
            disabled={!currentAvatar}
            content={"Valider l'avatar"}
            variant={'primaryGreen'}
            onClick={e => {
              e.preventDefault();
              updateUserAvatar({
                variables: {
                  user: userid,
                  avatar: currentAvatar
                }
              });
            }}
          />
        </div>
      </FeatureContainer>
    </div>
  );
};
